export default __webpack_public_path__ + "static/Canary_Wharf-656ce7e2dcdb4da3d40a364b3b2b6afb.png";